/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// Temp state - uses 'product' layout until the real layout option is picked
export const whatsAppResponseProductMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("product"),
});
